/** تعداد ردیف محصول در لندینگ — همیشه ۲ ردیف */
export const LANDING_CATALOG_ROWS = 2;

/** حداکثر ستون (lg+) × ردیف — برای fetch از API */
export const LANDING_CATALOG_FETCH_LIMIT = 8;

export function getLandingCatalogVisibleCount(columns) {
  return Math.max(1, columns) * LANDING_CATALOG_ROWS;
}

/** ستون‌های گرید محصول مطابق breakpointهای ServicesSection */
export function resolveCatalogGridColumns(viewportWidth) {
  if (viewportWidth >= 1024) return 4;
  if (viewportWidth >= 768) return 3;
  if (viewportWidth >= 640) return 2;
  return 1;
}
